import { Button, sendToSentry } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/atoms/typography'
import { useEffect } from 'react'

type ErrorFallbackProps = {
    error: Error
    resetErrorBoundary: () => void
}

const userText = {
    somethingWentWrong: 'Es ist ein Fehler aufgetreten',
    tryAgain: 'Erneut versuchen',
}

export default function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
    useEffect(() => {
        sendToSentry(error)
    }, [error])

    return (
        <div role="alert">
            <Typography>{userText.somethingWentWrong}</Typography>
            <pre>{error.message}</pre>
            <Button variant="secondary" label={userText.tryAgain} onClick={resetErrorBoundary} />
        </div>
    )
}
